import { useEffect, useState } from "react";
import { IAutomationObject } from "../../automationObjects";
import { IDashboardCollection } from "./types";
import { useRemoveDashboardItem } from "../../hooks/useRemoveDashboardItem";
import { Button } from "baseui/button";
import RemoveItemDialog from "./RemoveItemDialog";
import { VscTrash } from "react-icons/vsc";

const ActionButtons = (props: { dashboard: IDashboardCollection, app: IAutomationObject, onItemRemoved: () => void }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [remove, result] = useRemoveDashboardItem();

    useEffect(() => {
        if (result.isSuccess)
            props.onItemRemoved();
    }, [result])

    return (
        <>
            <Button size='compact' kind='tertiary' shape='circle' onClick={(e) => { e.preventDefault(); setIsOpen(true); }}><VscTrash /></Button>
            <RemoveItemDialog objectDescription={props.app.description} isOpen={isOpen} setIsOpen={setIsOpen} onOk={onOk}></RemoveItemDialog>
        </>
    )

    function onOk(e: any) {
        remove(props.dashboard, props.app)
        setIsOpen(false);
    }
}

export default ActionButtons;